import { createAsyncThunk } from '@reduxjs/toolkit'

import axiosInstance from 'libraries/axios'

export const getStore = createAsyncThunk('get/store', async (_, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.get(`/v1/store/${window.config.STORE_ID}`)

    return data.data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})

export const getCategoriesTree = createAsyncThunk('get/categories/tree', async (_: any, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.get(`/v1/categories/tree?parent_id=${window.config.CATEGORY_ID}`)

    return data.data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})

export const getCategories = createAsyncThunk('get/categories', async (body: any, { dispatch, rejectWithValue }) => {
  try {
    const categoriesTreeResult = await dispatch(getCategoriesTree(body)).unwrap()

    let data
    if (window.config.IS_SUPPLIER) {
      const response = await axiosInstance.post(`/suppliers/v3/categories`, {
        filter_has_products: true,
        filter_customer_id: window.config.CUSTOMER_ID,
      })
      data = response.data
    } else {
      const response = await axiosInstance.post(`/v2/categories`, {
        filter_parent_id: window.config.CATEGORY_ID,
        filter_with_products: true,
      })
      data = response.data
    }

    return data.data.map((category: any) => {
      const matchingCategory = categoriesTreeResult.find((treeCategory: any) => treeCategory.id === category.id)

      if (matchingCategory) {
        return {
          ...category,
          children: matchingCategory.childrens,
        }
      }

      return category
    })
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})
